$(document).ready(function () {

var initAjaxProSlider__topbar = {
          dots: true,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
};  
  
    $(".searchToggle").on("click", function (e) {
        $("#searchBar").toggleClass("open");
        e.preventDefault();
    });
    $("#crt").on("click", "a.remove_item", function () {
        console.log("removing item");
        var id = $(this).data("id");
        $.ajax({ type: "POST", url: "/cart/update.js?updates[" + id + "]=0", async: !1, error: removeError, success: removeSuccess, cache: !1 });
    });
    function removeError() {
        console.log("removeError");
        updateCartPopup();
    }
    function removeSuccess() {
        console.log("removeSuccess");
        updateCartPopup();
    }
    function updateCartPopup() {
        jQuery.getJSON("/cart.js", function (cart) {
            console.log(cart.item_count);
            if (cart.item_count == 0) {
                $("#crt").hide();
            }
            $(".quick-cart-item").remove();
            $(".CartCount").text(cart.item_count);
            for (var i = cart.items.length - 1; i >= 0; i--) {
                let cartItem = cart.items[i];
                let html_cart_ob =
                    `<div class="quick-cart-item">
				<div class="quick-cart-image">
				<a href="` +
                    cartItem.url +
                    `">
				<img class=" lazyloaded" data-src="` +
                    cartItem.featured_image.url +
                    `" alt="label" src="` +
                    cartItem.featured_image.url +
                    `">        
				</a>
				</div>
				<div class="quick-cart-details">
				<p><a href="` +
                    cartItem.url +
                    `">` +
                    cartItem.title +
                    `</a></p><p>
				</p><p><span class="money" data-currency-usd="` +
                    Shopify.formatMoney(cartItem.price) +
                    ` USD" data-currency="USD">` +
                    Shopify.formatMoney(cartItem.price) +
                    ` USD</span></p>        
				<a class="remove_item" href="#" data-id="` +
                    cartItem.id +
                    `" data-activator="#">Remove</a>
				</div>
				</div>`;
                $("#crt").prepend(html_cart_ob);
            }
        });
    }
    // Upsell popup logic — listens for theme.js's successful add-to-cart event.
    // (Previously this file fired its own $.ajax to /cart/add.js, causing duplicate cart adds.)
    document.addEventListener('devst:cart-item-added', function (e) {
        if (e.detail && !e.detail.isQuickview) {
            addToCartSuccess(e.detail.item);
        }
    });
    function addToCartSuccess(jqXHR, textStatus, errorThrown) {
        const itemData = jqXHR;
        $(".product-added__image").attr("src", itemData.image);
        $(".product-added__title").text(itemData.title);
        $(".upsell").addClass("upsell--open");
      
        //$.ajax({ type: "GET", url: "/cart.js", async: !1, cache: !1, dataType: "json", success: updateCartPopup });
       // $("#crt").show().delay(3000).fadeOut();
        //var link = '<a href="/cart">' + LS.localization.variable("products.product.add_to_cart_success_link", "View Cart and Check out!", "", "") + "</a>";
        var sliderAjaxProSlider_topbar = $("#related_popup_container .upsell-product-recommendations-loop"); 
        var initAjaxProSlider__topbar = {
                  dots: true,
                  infinite: true,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  autoplay: true,
                  autoplaySpeed: 2000,
                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
        };        
        if($("#related_popup_container").length){
            sliderAjaxProSlider_topbar.not(".slick-initialized").slick(initAjaxProSlider__topbar);
        }      
    }
    function addToCartFail(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        $(".add-to-cart-msg").addClass("error").text(response.description).fadeIn().delay(3000).fadeOut();
    }
    if (window.innerWidth < 740) {
        $(".mthumb img").click(function () {
            var product_image = $(this);
            var product_alt = $(this).attr("alt");
            if (product_alt.indexOf("iframe") != -1) {
                if ($(this).find("iframe").length) {
                    $(".mthumb img iframe").replaceWith(product_alt);
                    product_image.hide();
                } else {
                    $(product_alt).insertAfter(product_image);
                    product_image.hide();
                }
            } else {
                $(".mthumb img iframe").remove();
                product_image.show();
            }
        });
    }
    $(window).on("scroll", function (e) {
        const scrollTop = $(window).scrollTop();
        $("body").hasClass("loading-more") ? $(".infinite-loading-image").show() : $(".infinite-loading-image").hide();
        if ($(".more").length > 0) {
            const target = $(".more").offset().top - 200;
            if ($("body").is(":not(.loading-more)") && scrollTop >= target) {
                loadMore();
            }
        }
    });
    const loadMore = function () {
        const ajaxSettings = {
            url: $(".more").attr("href"),
            method: "get",
            datatype: "html",
            beforeSend: function () {
                $("body").addClass("loading-more");
            },
            success: function (data) {
                const newProducts = $(data).find("#product-loop").html();
                const newUrl = $(data).find(".more").attr("href");
                $("#product-loop").append(newProducts);
                if (newUrl) $(".more").attr("href", newUrl);
                else $(".more").remove();
                $("body").removeClass("loading-more");
            },
            error: function (message) {
                console.log(message);
            },
        };
        $.ajax(ajaxSettings);
    };
});

